import type { ActivationClaims } from '@infra/licence/ActivationClaims';

export type LicenseKeyType = 'cabinet' | 'client';

/**
 * Type commercial de clé (SEC C4).
 * Priorité au claim `key_type` ; repli legacy : portefeuille signé ⇒ cabinet.
 */
export function resolveLicenseKeyType(claims: ActivationClaims | null | undefined): LicenseKeyType {
  if (!claims) return 'client';
  if (claims.key_type === 'cabinet' || claims.key_type === 'client') {
    return claims.key_type;
  }
  if (claims.cabinet === true && typeof claims.cabinet_group_id === 'string') {
    return 'cabinet';
  }
  return 'client';
}

/** Clé commerciale de type Cabinet (portefeuille), pas seulement un dossier rattaché. */
export function isCabinetLicenseKey(claims: ActivationClaims | null | undefined): boolean {
  return resolveLicenseKeyType(claims) === 'cabinet';
}
